import { StateCreator } from 'zustand'
import { InviteLinksState } from '../state'
import {
    TrafficSourceOptionType,
    DetalizationOptionType,
    UsersSortOptionType,
    typedUsersSortOptions,
    typedDetalizationSortOptions,
    typedTrafficSourceSortOptions,
    SubscriberStatusSortOptionType,
    typedSubscriberStatusSortOptions,
} from '../../constants'

export interface RetentionFeatureSlice {
    trafficSourceSortRetention: TrafficSourceOptionType
    detalizationSortRetention: DetalizationOptionType
    usersSortRetention: UsersSortOptionType
    subscriberStatusSortRetention: SubscriberStatusSortOptionType
    startDateRetention: string
    endDateRetention: string
    selectedLinksRetentionByGroup: {
        [groupId: number]: number[]
    }
    selectedLinksRetentionByChannel: {
        [channelId: number]: number[]
    }
    setStartDateRetention: (value: string) => void
    setEndDateRetention: (value: string) => void
    setTrafficSourceSortRetention: (value: TrafficSourceOptionType) => void
    setDetalizationSortRetention: (value: DetalizationOptionType) => void
    setUsersSortRetention: (value: UsersSortOptionType) => void
    setSubscriberStatusSortRetention: (
        value: SubscriberStatusSortOptionType
    ) => void
    toggleSelectedLinkRetentionByGroup: (
        groupId: number,
        linkId: number,
    ) => void
    clearSelectedLinksRetentionByChannel: (channelId: number) => void
}

export const createRetentionFeatureSlice: StateCreator<
    InviteLinksState,
    [],
    [],
    RetentionFeatureSlice
> = (set) => ({
    trafficSourceSortRetention: typedTrafficSourceSortOptions[0],
    detalizationSortRetention: typedDetalizationSortOptions[0],
    usersSortRetention: typedUsersSortOptions[0],
    subscriberStatusSortRetention: typedSubscriberStatusSortOptions[0],
    selectedLinksRetentionByGroup: {},
    selectedLinksRetentionByChannel: {},
    startDateRetention: '',
    endDateRetention: '',

    setStartDateRetention: (value) => set({ startDateRetention: value }),
    setEndDateRetention: (value) => set({ endDateRetention: value }),
    setTrafficSourceSortRetention: (value) =>
        set({ trafficSourceSortRetention: value }),
    setDetalizationSortRetention: (value) =>
        set({ detalizationSortRetention: value }),
    setUsersSortRetention: (value) => set({ usersSortRetention: value }),
    setSubscriberStatusSortRetention: (value) =>
        set({ subscriberStatusSortRetention: value }),
    toggleSelectedLinkRetentionByGroup: (
        groupId: number,
        linkId: number
    ) => {
        set((state) => {
            let selected = state.selectedLinksRetentionByGroup[groupId] || []

            if (selected.includes(linkId)) {
                selected = selected.filter((id) => id !== linkId)
            } else {
                selected = [...selected, linkId]
            }

            return {
                selectedLinksRetentionByGroup: {
                    ...state.selectedLinksRetentionByGroup,
                    [groupId]: selected,
                },
            }
        })
    },
    clearSelectedLinksRetentionByChannel: (channelId: number) => {
        set((state) => ({
            selectedLinksRetentionByChannel: {
                ...state.selectedLinksRetentionByChannel,
                [channelId]: [],
            },
        }))
    },
})
